import { render } from "./GoodsList.vue?vue&type=template&id=993ff094&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"

import "./GoodsList.vue?vue&type=style&index=0&id=993ff094&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-993ff094"]])

export default __exports__